<template>
    <div class="bodyclass">
        <!--首页大框-->
        <div class="top-box-ins">
            <!--菜单-->
            <div class="top-menu">
                <div class="top-menu-t clearfloat">
                    <div class="menu-logo fl"></div>
                    <div class="menu-txt fl">
                        <ul class="li-div-txt">
                            <li><a class="dbi fb w100 menu-atxt" href="/">首页</a></li>
                            <li> <a class="dbi fb w100 menu-atxt" href="/chanping1">产品</a>
                                <div class="li-div" style="width:1000px;">
                                    <div class="li-div-left fl"> <span class="tl dbi">产品</span> </div>
                                    <div class="w68 fl">
                                        <ul class="li-div-txt">
                                            <li class="" style="width:23%"> 
                                                <a class="dbi  w100 menu-atxt" href="/chanping4">
                                                <div class="li-div-d2 mt10 "> 
                                                    <img src="../assets/images/z13-ytj.png" class="li-div-img">
                                                </div>
                                                <h1 class="f16 lh20 mt10 dbi">视觉智能体</h1>
                                                </a> 
                                            </li>
                                            <li style="width:23%"> 
                                                <a class="dbi w100 menu-atxt" href="/chanping3">
                                                <div class="li-div-d2 mt10"> 
                                                    <img src="../assets/images/z12-ytj.png" class="li-div-img">
                                                </div>
                                                <h1 class="f16 lh20 mt10 dbi">新一代公共安全视觉智能体</h1>
                                                </a> 
                                            </li>
                                            <li class="" style="width:23%"> <a class="dbi  w100 menu-atxt"
                                                    href="/chanping1">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z1-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                                                </a> </li>
                                            <li style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping2">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z2-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh40">视觉大模型一体机</h1>
                                                </a> </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li><a class="dbi fb w100 menu-atxt" href="/jiejfa1">解决方案</a>
                                <div class="li-div" style="width:1300px;">
                                    <div class="li-div-left fl" style="width:220px"> <span class="tl dbi">解决方案</span>
                                    </div>
                                    <div class="w70 fl" style="height:148px;">
                                        <ul class="">
                                            <li> <a class="dbi  w100 menu-atxt" href="/jiejfa1">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh40 ">公共安全行业解决方案</h1>
                                                </a> </li>
                                            <li> <a class="dbi  w100 menu-atxt" href="/yijii2">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh40">应急行业解决方案</h1>
                                                </a> </li>
                                            <li> <a class="dbi  w100 menu-atxt" href="/chengguan3">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh40">城管行业解决方案</h1>
                                                </a> </li>
                                            <li> <a class="dbi  w100 menu-atxt" href="/jiaotong4">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh40">交通行业解决方案</h1>
                                                </a> </li>
                                            <li> <a class="dbi  w100 menu-atxt" href="/qiyeigl5">
                                                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png"
                                                            class="li-div-img"></div>
                                                    <h1 class="f16 lh40">企业管理解决方案</h1>
                                                </a> </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li><a class="dbi fb w100 menu-atxt" href="/severHtml">服务&生态</a></li>
                            <li><a class="dbi fb w100 menu-atxt" href="/gywmHtml">关于我们</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <!--菜单end-->

            <!--背景图-->
            <div class="top-backgr">
                <div class="top-box-ins-img bgimg"  ></div>
                <div class="top-box-ins-imga1 bgimg2"  ></div>
            </div>
            <!-- <div class="top-backgr">
                <div class="top-box-ins-img"
                    style="background:url(../assets/images/bana-5.jpg) center center no-repeat;background-size:cover;"></div>
                <div class="top-box-ins-imga1"
                    style="background:url(../assets/images/z9-ytj.png) center center no-repeat;background-size:cover;"></div>
            </div> -->
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="main pt84">

            <!--解决方案-->
            <div class="w100 lh40 tc  WOW animate__animated animate__fadeInUp"> 
                <span class="db f48 fb lp2 mt40">公共安全行业解决方案</span> 
                <span
                    class="db f24  lp2 mt10 col-gr">Security Industry Solutions</span> 
                </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">行业痛点</p>
                <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">追踪能力有限</span></strong><br>
                    传统视频及追踪系统功能单一，仅能针对录入系统的固定人员，凭借人脸识别技术实现定位与追踪。一旦面对嫌疑人具备多种特征素材，如不同伪装下的外貌特征、特殊肢体动作习惯，或是多种特征组合情况，系统便难以精准定位，无法有效锁定目标。
                </p>
                <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">无法实时预警</span></strong><br>
                    当前视频系统难以从海量视频数据中提前识别潜在风险，无法依据视频分析对可能发生的危险行为、可疑人员聚集等情况发出预警，错过防控风险的最佳时机。</p>
                <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;"><strong class="mb10 dbi"><span style="color:rgb(255,0,0);">人工筛查低效</span></strong><br>
                    面对突发安全事件，需快速从大量视频监控中获取关键信息。目前主要依靠大量警力进行人工监控筛查，人工筛查易因疲劳、注意力分散等因素产生错漏，导致重要线索被忽视。</p>
            </div>
            <!--解决方案end-->

            <!--产品-->
            <div class="sthz clearfloat ov mt50">
                <div class="w100 tc mt100 white WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;"> 
                    <span class="db f48 fb lp2 mt40">方案架构</span> 
                    <span
                        class="db f24  lp2 mt10 ">Solution Architecture</span> 
                    </div>
                <div class="jcrj jz mt30  WOW animate__animated animate__fadeInRight" style="animation-delay: 0.3s;">
                    <div class="jcrj-a jz mt50">
                        <img src="../assets/images/za6-ytj.png" width="100%" alt="" />
                    </div>
                </div>
            </div>

            <!--产品end-->
        </div>
        <!--内容大框end-->
        <div class="w100 lh40 tc mt100 ">
            <span class="db f48 fb lp2 mt40  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">应用场景</span>
            <span class="db f24  lp2 mt10 col-gr  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">Application Scenario</span>
        </div>

        <div class="yycjdi jz mt50">
            <ul class="w100">
                <li class="ov WOW animate__animated animate__fadeInUp" style="animation-delay: 0.1s;">
                    <img src="../assets/images/gan-1.jpg" width="100%" height="100%" alt=""  />
                    <div class="rig-box ">
                        <div class="col-gr4 f36 mt30 pl30">01</div>
                        <div class="col-gr5 f16 tc fb">暴力攻击行为识别</div>
                        <div class="white f16 tc pt40">打架 互殴 等行为</div>
                    </div>
                </li>
                <li class="ov WOW animate__animated animate__fadeInUp" style="animation-delay: 0.2s;">
                    <img src="../assets/images/gan-2.jpg" width="100%" height="100%" alt=""  />
                    <div class="rig-box  WOW ">
                        <div class="col-gr4 f36 mt30 pl30">02</div>
                        <div class="col-gr5 f16 tc fb">警务人员力量识别</div>
                        <div class="white f16 tc pt40">警员、各类警务车辆识别</div>
                    </div>
                </li>
                <li class="ov WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">
                    <img src="../assets/images/gan-3.jpg" width="100%" height="100%" alt=""  />
                    <div class="rig-box  ">
                        <div class="col-gr4 f36 mt30 pl30">03</div>
                        <div class="col-gr5 f16 tc fb">拉条幅行为识别</div>
                        <div class="white f16 tc pt40">拉条幅行为及条幅内容</div>
                    </div>
                </li>
                <li class="ov WOW animate__animated animate__fadeInUp" style="animation-delay: 0.4s;">
                    <div class="rig-box " >
                        <div class="col-gr4 f36 mt30 pl30">04</div>
                        <div class="col-gr5 f16 tc fb">遛狗不牵绳识别</div>
                        <div class="white f16 tc pt40">重点区域遛狗不牵绳</div>
                    </div>
                    <img src="../assets/images/gan-4.jpg" width="100%" height="100%" alt=""  />
                </li>
                <li class="ov WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">
                    <div class="rig-box ">
                        <div class="col-gr4 f36 mt30 pl30">05</div>
                        <div class="col-gr5 f16 tc fb">监所羁押人员行为识别</div>
                        <div class="white f16 tc pt40">打架自残等危险行为识别</div>
                    </div>
                    <img src="../assets/images/gan-5.jpg" width="100%" height="100%" alt=""  />
                </li>
                <li class="ov WOW animate__animated animate__fadeInUp" style="animation-delay: 0.6s;">
                    <div class="rig-box ">
                        <div class="col-gr4 f36 mt30 pl30">06</div>
                        <div class="col-gr5 f16 tc fb">同行人关系识别</div>
                        <div class="white f16 tc pt40">多人同行识别</div>
                    </div><img src="../assets/images/gan-6.jpg" width="100%" height="100%" alt=""  />
                </li>

            </ul>
        </div>
        <!--底宣-->
        <div class="btto-a1 mt100 ov">
      <div class="btto-a2 jz mt30">
        <ul class="w100 he68">
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;">
            <div class="btt-ico fl ">
              <img src="../assets/images/za1-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">全场景算法</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">algorithm</span>
              </div>
              <div class="mt4 col-gr3">多种行业全场景算法</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.3s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za2-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">算法灵活自定义</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Custom</span>
              </div>
              <div class="mt4 col-gr3">可通过文字自定义描述方式新增修改</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.5s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za3-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">国产化生态支持</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">support</span>
              </div>
              <div class="mt4 col-gr3">基于自主可控的国产化IT底层架构</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.7s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za4-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">完善标准化</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">standardization</span>
              </div>
              <div class="mt4 col-gr3">支持主流音视频标准化协议</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.9s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za5-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">大模型技术</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Large Model</span>
              </div>
              <div class="mt4 col-gr3">使用Transformer架构</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
        <!--底宣end-->
         <!--底宣2-->
    <div class="btto-b-a1 ov">
      <div class="mt30 w100 jz dbi">
        <div class="tc WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;"> <img src="../assets/images/ying-28.jpg" width="76" height="76" alt="" class="  dbi " /></div>
        <ul class="w100 he92 tc mt20">
          <li class=" WOW animate__animated animate__fadeInRight animate__duration-5s dbi" style="animation-delay: 0.1s;">
            <div class="tl f24 white he35 fl">上海谛视万象科技有限公司</div>
            <div class="ov  fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_3.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">联系电话：4007628008</span>
            </div>
          <!--  <div class="ov fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_1.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">地址：上海市普陀区真北路2653号天地科技园</span>
            </div>-->
          </li>
                   
        </ul>
      </div>
    </div>
    <!--底宣2end--> 
        <!--底宣3-->
        <div class="he90 tc btto-c"> <span class="dbi col-gr3  mt30 mr40">辽ICP备2025061615号</span> <span class="dbi col-gr3  mt30">Copyright © 2004 - 2025 谛视万象版权所有</span></div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
// , onUpdated, onUnmounted, ref
import { onMounted } from 'vue';
import * as WOW from 'wowjs';
// let wowInstance = null;
onMounted(() => {
    new WOW.WOW({
        // boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 50,       // 元素进入视口 100px 后触发
        // mobile: true,      // 移动端启用
        live: true,        // 监听动态添加的元素
    }).init();
})
</script>
<style scoped>
@import '@/assets/css/default.css';
@import '@/assets/css/font-awesome.min.css';
@import '@/assets/css/margin.css';
@import '@/assets/css/main.css';

/* style="background:url(../assets/images/bana-9.jpg) center center no-repeat;background-size:cover;" */
/* style="background:url(../assets/images/z8-ytj.png) center center no-repeat;background-size:cover;" */
.bgimg {
    background: url(../assets/images/bana-5.jpg) center center no-repeat;
    /* background-size: 100% auto;
    width: 100vw; */
    background-size: cover;
}

.bgimg2 {
    background: url(../assets/images/z9-ytj.png) center center no-repeat;
    background-size: cover;
}

.animate__animated {
    animation-duration: 2s !important;
}
</style>